import Rectangle from "./Rectangle";
import RightAngledTriangle from "./RightAngledTriangle";
import Length from "./Length";
import AbstractShape from "./AbstractShape";
import SlopedRectangle from "./SlopedRectangle";

export default class AbstractSlopedRectangle extends AbstractShape {
	constructor( width, height_left, height_right ) {
		super();

		this.width = width;
		this.height_left = height_left;
		this.height_right = height_right;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.width, this.get_longest_height() );
	}

	get_area() {
		const largest_height = this.get_longest_height();
		const smallest_height = this.get_shortest_height();
		const base_rectangle = new Rectangle( this.width, this.get_shortest_height() );
		const top_triangle = new RightAngledTriangle( this.width, largest_height.subtract( smallest_height ) );
		return base_rectangle.get_area().add( top_triangle.get_area() );
	}

	get_circumference() //Pythagorean theorem, a^2 + b^2 = c^2
	{
		const diagonal_length = Math.sqrt( Math.pow( this.width.in_mm(), 2 ) + Math.pow( this.get_longest_height().subtract( this.get_shortest_height() ).in_mm(), 2 ) );
		return this.width.add( this.height_left ).add( this.height_right ).add( new Length( diagonal_length ) );
	}

	get_longest_height() {
		return this.height_left.max( this.height_right );
	}

	get_shortest_height() {
		return this.height_left.min( this.height_right );
	}

	get_width() {
		return this.width;
	}

	get_height_left() {
		return this.height_left;
	}

	get_height_right() {
		return this.height_right;
	}

	get_maximum_dimensions( maximum_rectangle ) {
		return {
			width: maximum_rectangle.get_width(),
			height_left: maximum_rectangle.get_longest_side(),
			height_right: maximum_rectangle.get_longest_side()
		};
	}

	get_dimension_keys() {
		return ["height_left", "width", "height_right"];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			width: this.width.in_mm(),
			height_left: this.height_left.in_mm(),
			height_right: this.height_right.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new SlopedRectangle( new Length( primitives.width ), new Length( primitives.height_left ), new Length( primitives.height_right ) );
	}

}
